import React from 'react';
import FaqSection from '../../components/features/faq/FaqSection';

export default function FaqPage() {
  return (
    <div className="space-y-6 animate-fade-in px-4">
      <FaqSection showTitle={true} />
    </div>
  );
}
